import type { FC } from 'react';
import { ProductType } from '../../../../../products/types';
import { useTranslation } from 'react-i18next';
import ProductTypeIcon from '../../../../SoldProducts/ProductTypeIcon';
import Flex from '@wix/da-ds/pkg/Flex';
import { PapiDataPackageSellerSubscriptionOverview } from '@wix/da-papi-types';

import s from './SoldSubscriptionsTableRowHeadingMobile.scss';

interface Props {
  item: NonNullable<
    PapiDataPackageSellerSubscriptionOverview['timePeriods']['ALL']
  >[number];
}

const SoldSubscriptionsTableRowHeadingMobile: FC<Props> = ({ item }) => {
  const { t } = useTranslation();

  const { productName, deviation, numSubscribers } = item;

  return (
    <div className={s['root']}>
      <ProductTypeIcon productType={ProductType.Tier} size={40} />
      <Flex direction="column" gap={4}>
        <div className={s['title']}>
          {productName || (deviation && deviation.title)}
        </div>
        <div className={s['subscriber-count']}>
          {t(
            'studio.reports.section.soldSubscriptions.table.activeSubscriberCount',
            { count: numSubscribers ?? 0 }
          )}
        </div>
      </Flex>
    </div>
  );
};
SoldSubscriptionsTableRowHeadingMobile.displayName =
  'SoldSubscriptionsTableRowHeadingMobile';

export default SoldSubscriptionsTableRowHeadingMobile;
